import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { dataTableSection } from '../../constants';
import { useTableContext } from '../../context';
import { StyledLabel, NoteWrapper } from './styled';
export const Note = memo(function Note({ label, value, dataTestId }) {
    const { compact } = useTableContext();
    return (_jsxs(NoteWrapper, { $compact: compact, ...dataTableSection, "data-testid": dataTestId, children: [_jsx(StyledLabel, { noMargin: true, children: label }), value] }));
});
